<script>
  let {
    data = {
      dailyWebsocketStatus: 'passed',
      dailyNetworkStatus: 'passed',
      dailyCallQuality: null,
      networkEffectiveType: '4g',
      networkDownlink: 6.05,
      networkRtt: 0,
      browserInfo: 'Chrome',
      osInfo: 'MacOS',
      screenResolution: '2560x1440',
      userAgent:
        'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36',
      microphonePermission: 'granted',
      cameraPermission: 'granted',
      devicePixelRatio: 1,
      isWebView: 0,
      cookiesEnabled: 1,
      localStorageAvailable: 1,
      onlineStatus: 1,
      logs: null,
    },
  } = $props();

  const getStatusColor = (status) => {
    switch (status) {
      case 'passed':
        return 'text-emerald-400';
      case 'failed':
        return 'text-red-400';
      case 'warning':
        return 'text-yellow-400';
      case 'granted':
        return 'text-emerald-400';
      case 'denied':
        return 'text-red-400';
      default:
        return 'text-gray-400';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'passed':
      case 'granted':
        return '✓';
      case 'failed':
      case 'denied':
        return '✗';
      case 'warning':
        return '⚠';
      default:
        return '•';
    }
  };
</script>

<div class="pl-4">
  <div class="grid grid-cols-1 gap-4 md:grid-cols-1">
    <!-- Connection Status -->
    <div class="space-y-2 rounded-md bg-gray-900/50 p-4">
      <h4 class="font-medium text-gray-300">Connection Status</h4>
      <div class="space-y-1">
        <div class="flex items-center justify-between text-gray-400">
          <span>WebSocket Status</span>
          <span class={getStatusColor(data.dailyWebsocketStatus)}>
            {getStatusIcon(data.dailyWebsocketStatus)}
            {data.dailyWebsocketStatus}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Network Status</span>
          <span class={getStatusColor(data.dailyNetworkStatus)}>
            {getStatusIcon(data.dailyNetworkStatus)}
            {data.dailyNetworkStatus}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Network Type</span>
          <span class="font-mono text-gray-300">
            {data.networkEffectiveType}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Network Speed</span>
          <span class="font-mono text-gray-300">
            {data.networkDownlink} Mbps
          </span>
        </div>
      </div>
    </div>

    <!-- Permissions -->
    <div class="space-y-2 rounded-md bg-gray-900/50 p-4">
      <h4 class="font-medium text-gray-300">Device Permissions</h4>
      <div class="space-y-1">
        <div class="flex items-center justify-between text-gray-400">
          <span>Camera</span>
          <span class={getStatusColor(data.cameraPermission)}>
            {getStatusIcon(data.cameraPermission)}
            {data.cameraPermission}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Microphone</span>
          <span class={getStatusColor(data.microphonePermission)}>
            {getStatusIcon(data.microphonePermission)}
            {data.microphonePermission}
          </span>
        </div>
      </div>
    </div>

    <!-- System Info -->
    <div class="space-y-2 rounded-md bg-gray-900/50 p-4">
      <h4 class="font-medium text-gray-300">System Information</h4>
      <div class="space-y-1">
        <div class="flex items-center justify-between text-gray-400">
          <span>Browser</span>
          <span class="font-mono text-gray-300">{data.browserInfo}</span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>OS</span>
          <span class="font-mono text-gray-300">{data.osInfo}</span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Resolution</span>
          <span class="font-mono text-gray-300">{data.screenResolution}</span>
        </div>
      </div>
    </div>

    <!-- Additional Info -->
    <div class="space-y-2 rounded-md bg-gray-900/50 p-4">
      <h4 class="font-medium text-gray-300">Additional Information</h4>
      <div class="space-y-1">
        <div class="flex items-center justify-between text-gray-400">
          <span>WebView</span>
          <span class="text-gray-300">{data.isWebView ? 'Yes' : 'No'}</span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Cookies</span>
          <span class="text-gray-300">
            {data.cookiesEnabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>LocalStorage</span>
          <span class="text-gray-300">
            {data.localStorageAvailable ? 'Available' : 'Unavailable'}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-400">
          <span>Online Status</span>
          <span class="text-gray-300">
            {data.onlineStatus ? 'Online' : 'Offline'}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
